import store from '@/store';
import { CLEAR_ACCOUNT_ISLOADING, CLEAR_ALLOWANCE_TYPE_ISLOADING, CLEAR_ATTENDANCE_LOG_ISLOADING, CLEAR_ATTENDANCE_SCHEDULE_ISLOADING, CLEAR_BANK_ISLOADING, CLEAR_DEPARTMENT_ISLOADING, CLEAR_EMPLOYEE_ADDRESS_ISLOADING, CLEAR_EMPLOYEE_ALLOWANCE_ISLOADING, CLEAR_EMPLOYEE_BANK_ISLOADING, CLEAR_EMPLOYEE_CONTRACT_ISLOADING, CLEAR_EMPLOYEE_EDUCATION_ISLOADING, CLEAR_EMPLOYEE_LEAVE_ISLOADING, CLEAR_EMPLOYEE_OVERTIME_ISLOADING, CLEAR_EMPLOYEE_PAYROLL_COMPONENT_ISLOADING, CLEAR_EMPLOYEE_PAYROLL_ISLOADING, CLEAR_EMPLOYEE_POSITION_ISLOADING, CLEAR_EMPLOYEE_SALARY_ISLOADING, CLEAR_EMPLOYEE_SALARY_PROMOTION_ISLOADING, CLEAR_EMPLOYEES_ISLOADING, CLEAR_FILE_ISLOADING, CLEAR_HOLIDAYS_ISLOADING, CLEAR_LEAVE_TYPE_ISLOADING, CLEAR_ORGANIZATION_ISLOADING, CLEAR_OVERTIME_SETTING_ISLOADING, CLEAR_PAYROLL_COMPONENT_ISLOADING, CLEAR_PAYROLL_ISLOADING, CLEAR_PAYROLL_PERIOD_ISLOADING, CLEAR_POSITION_ISLOADING, CLEAR_STATS_ISLOADING } from '@/store/action_types';

export const resetLoaders = () => {
  store.dispatch(CLEAR_ACCOUNT_ISLOADING);
  store.dispatch(CLEAR_ALLOWANCE_TYPE_ISLOADING);
  store.dispatch(CLEAR_ATTENDANCE_LOG_ISLOADING);
  store.dispatch(CLEAR_ATTENDANCE_SCHEDULE_ISLOADING);
  store.dispatch(CLEAR_BANK_ISLOADING);
  store.dispatch(CLEAR_DEPARTMENT_ISLOADING);
  store.dispatch(CLEAR_EMPLOYEE_ADDRESS_ISLOADING);
  store.dispatch(CLEAR_EMPLOYEE_ALLOWANCE_ISLOADING);
  store.dispatch(CLEAR_EMPLOYEE_BANK_ISLOADING);
  store.dispatch(CLEAR_EMPLOYEE_CONTRACT_ISLOADING);
  store.dispatch(CLEAR_EMPLOYEE_EDUCATION_ISLOADING);
  store.dispatch(CLEAR_EMPLOYEE_LEAVE_ISLOADING);
  store.dispatch(CLEAR_EMPLOYEE_OVERTIME_ISLOADING);
  store.dispatch(CLEAR_EMPLOYEE_PAYROLL_COMPONENT_ISLOADING);
  store.dispatch(CLEAR_EMPLOYEE_PAYROLL_ISLOADING);
  store.dispatch(CLEAR_EMPLOYEE_POSITION_ISLOADING);
  store.dispatch(CLEAR_EMPLOYEE_SALARY_PROMOTION_ISLOADING);
  store.dispatch(CLEAR_EMPLOYEE_SALARY_ISLOADING);
  store.dispatch(CLEAR_EMPLOYEES_ISLOADING);
  store.dispatch(CLEAR_FILE_ISLOADING);
  store.dispatch(CLEAR_HOLIDAYS_ISLOADING);
  store.dispatch(CLEAR_LEAVE_TYPE_ISLOADING);
  store.dispatch(CLEAR_ORGANIZATION_ISLOADING);
  store.dispatch(CLEAR_OVERTIME_SETTING_ISLOADING);
  store.dispatch(CLEAR_PAYROLL_COMPONENT_ISLOADING);
  store.dispatch(CLEAR_PAYROLL_PERIOD_ISLOADING);
  store.dispatch(CLEAR_PAYROLL_ISLOADING);
  store.dispatch(CLEAR_POSITION_ISLOADING);
  store.dispatch(CLEAR_STATS_ISLOADING);
};
